import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './ContentFooter.css';

class ContentFooter extends Component {
  static propTypes = {
    shareUrl: PropTypes.string.isRequired,
  };

  render() {
    const { shareUrl } = this.props;

    return (
      <footer className={classnames('container', styles.footer)}>
        <div className="row">
          <a
            href={`javascript:void((function()%7Bvar%20e=document.createElement('script');e.setAttribute('type','text/javascript');e.setAttribute('charset','UTF-8');e.setAttribute('src','http://assets.pinterest.com/js/pinmarklet.js?r='+Math.random()*99999999);document.body.appendChild(e)%7D)());`}
          ><span className={styles.pinterestShare} /></a>
          <a
            href={`http://www.facebook.com/share.php?u=${encodeURIComponent(shareUrl)}`}
            target="_blank" rel="noopener noreferrer"
          ><span className={styles.snsShare} /></a>
          <p className={styles.shareLabel}>Share</p>
        </div>
      </footer>
    );
  }
}

export default ContentFooter;



// WEBPACK FOOTER //
// ./src/components/content-footer/ContentFooter.js